import { URL_TYPES } from '@wix/wix-vod-constants/common';
import { InternalError } from '@wix/wix-vod-constants/api-types';
import { toError } from '../../parsers/to-error';
import getThumbnail from './parsers/get-thumbnail';
import { YoutubeService } from './pixwix/youtube';
import { parseYoutubeChannel } from './parsers/channel';
export class YoutubeChannelsService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.youtubeService = new YoutubeService(httpClient);
    }
    async getChannelsByIds(ids) {
        return this.youtubeService
            .getChannelsByIds(ids)
            .then((response) => _.map(response.data.items, (channel) => parseYoutubeChannel(URL_TYPES.CHANNEL, channel)))
            .then((channels) => this.setMissingCovers(channels))
            .then((channels) => {
            const realIds = _.map(channels, 'externalId');
            return [
                ...channels,
                ...this.extendWithRemovedItems(ids, realIds, URL_TYPES.CHANNEL),
            ];
        })
            .then((channels) => ({ data: channels }))
            .catch(toError);
    }
    async getChannelsByUserName(userName) {
        return this.youtubeService
            .getChannelsByUsername(userName)
            .then((response) => _.map(response.data.items, (channel) => parseYoutubeChannel(URL_TYPES.CHANNEL, channel)))
            .then((channels) => this.setMissingCovers(channels))
            .then((channels) => ({ data: channels }))
            .catch(toError);
    }
    async getPlaylistsByIds(ids) {
        return this.youtubeService
            .getPlayListsByIds(ids)
            .then((response) => _.map(response.data.items, (channel) => parseYoutubeChannel(URL_TYPES.PLAYLIST, channel)))
            .then((playlists) => {
            const realIds = playlists.map((playlist) => playlist.externalId);
            return [
                ...playlists,
                ...this.extendWithRemovedItems(ids, realIds, URL_TYPES.PLAYLIST),
            ];
        })
            .then((playlists) => ({ data: playlists }))
            .catch(toError);
    }
    extendWithRemovedItems(originalIds, realIds, urlType) {
        const removedIds = _.difference(originalIds, realIds);
        return _.map(removedIds, (id) => parseYoutubeChannel(urlType, {
            id,
            isExternalRemoved: true,
        }));
    }
    async getChannelsByUrl(url) {
        let type;
        let id;
        try {
            const result = this.youtubeService.parseChannelUrl(url);
            type = result.type;
            id = result.id;
        }
        catch (e) {
            return Promise.reject(new InternalError(0, 'wpm_error.malformed_external_link'));
        }
        switch (type) {
            case URL_TYPES.PLAYLIST:
                return this.getPlaylistsByIds([id]);
            case URL_TYPES.USER_NAME:
                return this.getChannelsByUserName(id);
            default:
                return this.getChannelsByIds([id]);
        }
    }
    // 1. get all youtube channels without cover
    // 2. fetch covers for from related playlists
    // 3. extend with covers
    // TODO: filter youtube channels only before applying this
    async setMissingCovers(channels) {
        const channelsWithoutCovers = _.reject(channels, 'coverUrl');
        if (_.isEmpty(channelsWithoutCovers)) {
            return channels;
        }
        const playListIds = _.map(channelsWithoutCovers, 'uploadsPlaylistId');
        const videoCovers = await this.getFallbackCovers(playListIds);
        _.forEach(channelsWithoutCovers, (channel, index) => {
            channel.coverUrl = videoCovers[index] || null;
        });
        return channels;
    }
    async getCoverFromPlaylistItem(id) {
        return this.youtubeService
            .getPlaylistItems({
            urlType: URL_TYPES.PLAYLIST,
            externalId: id,
            itemsCount: 1,
        })
            .then((response) => response.data.items[0])
            .then((item) => item ? getThumbnail(item.snippet.thumbnails) : undefined);
    }
    async getFallbackCovers(playlistIds) {
        const requests = _.map(playlistIds, (id) => this.getCoverFromPlaylistItem(id).catch(() => undefined));
        return Promise.all(requests);
    }
}
//# sourceMappingURL=youtube-channels-service.js.map